import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { ECountry } from '@portals/help-center-core';
import { TSearchParams } from '@/_types/route-params';
import { getCategoriesRoute } from '@/_constants/routes';
import { Link } from '@/i18n/navigation';
import {
  ClientBackButton,
  TClientBackButtonProps,
} from './_components/client-back-button';
import styles from './index.module.scss';

type TProps = {
  backRoute?: string;
  searchParams: TSearchParams;
  isGoBackMode?: boolean;
  country: ECountry;
} & Pick<TClientBackButtonProps, 'pageType' | 'customEventParams'>;

const BLOCK_NAME = 'Back-Button';
const cn = classnames.bind(styles);

export const BackButton = ({
  isGoBackMode,
  backRoute,
  searchParams,
  pageType,
  customEventParams,
  country,
}: TProps) => {
  const routeName = backRoute || getCategoriesRoute({ country });
  const translations = useTranslations('help-center');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { categoryId, searchText, ...restSearchParams } = searchParams;

  const text = translations('goBack');

  const button = (
    <ClientBackButton
      customEventParams={customEventParams}
      isGoBackMode={isGoBackMode}
      pageType={pageType}
      text={text}
    />
  );

  return (
    <div className={cn(BLOCK_NAME)}>
      {isGoBackMode ? (
        button
      ) : (
        <Link
          href={{
            pathname: routeName,
            query: restSearchParams,
          }}
        >
          {button}
        </Link>
      )}
    </div>
  );
};
